import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import AdditionalInfo from "../Components/Product/AdditonInfo/AdditionalInfo";
import Product from "../Components/Product/ProductMain/Product";
import RelatedProducts from "../Components/Product/RelatedProducts/RelatedProducts";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase/config";
import CircleLoading from "../Components/CirculusIndicator/CircleLoading";
const ProductDetails = () => {
  const { productId } = useParams(); // Get product ID from URL
  const location = useLocation();
  const [product, setProduct] = useState(location.state?.product || null);
  const [loading, setLoading] = useState(!product);

  // useEffect(() => {
  //   if (!product) {
  //     const fetchProduct = async () => {
  //       setLoading(true);
  //       const docRef = doc(db, "products", productId);
  //       const docSnap = await getDoc(docRef);

  //       if (docSnap.exists()) {
  //         setProduct(docSnap.data());
  //         console.log(docSnap.data);
  //       } else {
  //         console.error("No such product!");
  //       }
  //       setLoading(false);
  //     };

  //     fetchProduct();
  //   }
  // }, [productId, product]);
  useEffect(() => {
    // If the same product is clicked, don't fetch again
    if (location.state?.product && location.state?.product.id === productId) {
      setProduct(location.state.product);
      setLoading(false);
      return;
    }


    if (!product) {
      console.log('fetch product call ');
      const fetchProduct = async () => {
        setLoading(true);
        const docRef = doc(db, "products", productId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setProduct(docSnap.data());
        } else {
          console.error("No such product!");
        }
        setLoading(false);
      };

      fetchProduct();
    }
  }, [productId, location.state?.product]);

  if (loading) return <div
    style={{
      display: 'flex',
      justifyContent: 'center',
    }}
  ><CircleLoading /></div>;
  if (!product) return <p>Product not found</p>;
  return (
    <>
      <Product product={product} />
      <AdditionalInfo product={product} />
      <RelatedProducts product={product} />
    </>
  );
};

export default ProductDetails;
